var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOndasTopcopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 399,
    viewBox: "0 0 495 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6444 70.7104L202.377 -89.5334C203.843 -90.8117 205.062 -92.3474 205.975 -94.0645C208.743 -99.2701 214.157 -102.523 220.053 -102.523H462.601C546.375 -102.523 614.115 -33.9066 614.091 49.8671C614.057 167.962 615 290.315 615 298.982C615 306.74 528.577 384.773 464.061 441.009C430.032 470.67 378.926 461.497 356.183 422.504C338.867 392.814 344.036 355.142 368.708 331.214L508.59 195.55C522.187 182.363 524.718 161.468 514.664 145.416C501.647 124.635 473.207 120.274 454.562 136.2L111.514 429.219C83.6341 453.032 41.5873 449.088 18.6235 420.504C-3.18279 393.361 0.270529 353.856 26.4555 330.909L263.947 122.779C280.159 108.571 282.974 84.3935 270.461 66.8409C256.662 47.4848 229.559 43.4381 210.708 57.9193L86.3777 153.428C59.6194 173.983 20.7454 164.927 5.82698 134.662C-4.89771 112.905 0.363543 86.6541 18.6444 70.7104Z",
    fill: "#A0D1DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndasTopcopy);
export default __webpack_public_path__ + "static/media/Ondas_Top copy.2aca7919da5388e392e7aa43550c7abe.svg";
export { ForwardRef as ReactComponent };